import { render, staticRenderFns } from "./EditAdminModal.vue?vue&type=template&id=171dfb25&scoped=true"
import script from "./EditAdminModal.vue?vue&type=script&lang=js"
export * from "./EditAdminModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171dfb25",
  null
  
)

export default component.exports